export default function FinalCTASection() {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-[#0F1E3D] via-[#1A365D] to-[#6B7FA3] py-16 md:py-20">
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      <div className="absolute top-0 right-0 w-[400px] h-[400px] rounded-full bg-[#C0C8D6]/8 blur-3xl -translate-y-1/2 translate-x-1/3"></div>
      <div className="absolute bottom-0 left-0 w-[350px] h-[350px] rounded-full bg-[#C0C8D6]/6 blur-3xl translate-y-1/2 -translate-x-1/4"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-6">
          The Passport Expediting Service That's Been Doing This for 20 Years
        </h2>
        <p className="text-white/80 text-base md:text-lg max-w-3xl mx-auto mb-8 leading-relaxed">
          Fast Passport Center has been registered with the U.S. Department of State for over 20 years, holds an A+ BBB rating, and has 24 physical drop-off locations nationwide. We are the courier — not a reseller. Direct access, direct pricing, real humans on the phone.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#C0C8D6] hover:bg-[#A8B2C4] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            Get Started With Fast Passport Center <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 border-2 border-white/30 hover:border-[#C0C8D6] text-white hover:text-[#C0C8D6] font-bold text-base px-8 py-4 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-5 md:gap-8">
          <div className="flex items-center gap-2 text-white/70 text-sm">
            <i className="ri-government-fill text-[#C0C8D6]"></i>
            <span>On Official State Dept. Registry</span>
          </div>
          <div className="flex items-center gap-2 text-white/70 text-sm">
            <i className="ri-shield-check-line text-[#C0C8D6]"></i>
            <span>A+ BBB</span>
          </div>
          <div className="flex items-center gap-2 text-white/70 text-sm">
            <i className="ri-user-star-line text-[#C0C8D6]"></i>
            <span>Direct Courier</span>
          </div>
          <div className="flex items-center gap-2 text-white/70 text-sm">
            <i className="ri-building-line text-[#C0C8D6]"></i>
            <span>24 Locations</span>
          </div>
          <div className="flex items-center gap-2 text-white/70 text-sm">
            <i className="ri-history-line text-[#C0C8D6]"></i>
            <span>20+ Years</span>
          </div>
          <div className="flex items-center gap-2 text-white/70 text-sm">
            <i className="ri-user-voice-line text-[#C0C8D6]"></i>
            <span>Real Humans</span>
          </div>
        </div>
      </div>
    </section>
  );
}